<template>
  <div class="location_selector" v-if="countriesinput && countriesinput.length > 0">
    <SearchAutocomplete
      :items="countriesinput"
      :label="labelCountry"
      ref="predpolCountryAutocomlete"
      v-model="country"
      v-if="$parent.isFieldVisible(countryKey)"
      :objectKey="countryKey"
      :isDataUpdating="isDataUpdating"
    ></SearchAutocomplete>

    <div class="columns">
      <div class="column">
        <SearchAutocompleteCities
            :items="citiestoinput"
            ref="predpolCityAutocomlete"
            v-model="city"
            :label="labelCity"
            :description="cityDescription"
            v-if="$parent.isFieldVisible(cityKey)"
            :objectKey="cityKey"
            :isDataUpdating="isDataUpdating"
            @onBlur="city=''"
        >
        </SearchAutocompleteCities>
      </div>
      <div class="column">
        <div class="field" @click="regionClick" v-if="$parent.isFieldVisible(regionKey)">
          <label :class="isFieldRequired(regionKey) ? 'req': ''">{{ labelRegion }}</label>
          <input :disabled="isDataUpdating" readonly @click="handleRegionClick" type="text" v-model="region">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchAutocomplete from "./../Base/SearchAutocomplete";
import axios from "axios";
import SearchAutocompleteCities from "./../Base/SearchAutocompleteCities";

export default {
  name: "BaseLocation.vue",
  props: {
    // Ключи, в родительском объекте для сохранения.
    countryKey: {},
    cityKey: {},
    regionKey: {},
    // Не обязательный параметр. Если хранится не в корне родительского объекта.
    parentObj: {},
    // Список стран для отображения.
    countriesinput: {},
    labelCountry: {},
    labelCity: {},
    labelRegion: {},
    isDataUpdating: {}
  },
  data() {
    return {
      country: (this.parentObj !== undefined  ? this.$parent.project[this.parentObj] ?. [this.countryKey] : this.$parent.project[this.countryKey]) === undefined ? "" : this.parentObj !== undefined ? this.$parent.project[this.parentObj][this.countryKey] : this.$parent.project[this.countryKey],
      city: (this.parentObj !== undefined ? this.$parent.project[this.parentObj] ?. [this.cityKey] : this.$parent.project[this.cityKey]) === undefined ? "" : this.parentObj !== undefined ? this.$parent.project[this.parentObj][this.cityKey] : this.$parent.project[this.cityKey],
      region: (this.parentObj !== undefined ? this.$parent.project[this.parentObj]?.[this.regionKey] : this.$parent.project[this.regionKey]) === undefined ? "" : this.parentObj !== undefined ? this.$parent.project[this.parentObj][this.regionKey] : this.$parent.project[this.regionKey],
      //Список городов для отображения
      citiestoinput: []
    };
  },
  components: {
    SearchAutocomplete,
    SearchAutocompleteCities
  },
  computed: {
    cityDescription() {
      if (this.country !== '' && this.country !== 'Российская Федерация' && this.country !== 'Казахстан' && this.country !== 'Беларусь' && this.country !== 'Украина') {
        return 'Название указывается латинскими буквами';
      }
      return '';
    }
	},
  async created() {
    await this.loadCities();
  },
  methods: {
    saveData() {
      if (this.parentObj !== undefined) {
        this.$parent.project[this.parentObj][this.countryKey] = this.country;
        this.$parent.project[this.parentObj][this.cityKey] = this.city;
        this.$parent.project[this.parentObj][this.regionKey] = this.region;
      } else {
        this.$parent.project[this.countryKey] = this.country;
        this.$parent.project[this.cityKey] = this.city;
        this.$parent.project[this.regionKey] = this.region;
      }
      this.$parent.saveData();
    },
    async loadCities() {
      const self = this;
      const current_country = self.countriesinput.filter(function(el) {return el["ru_name"] === self.country;})
      if (current_country[0] && current_country[0].number) {
        await axios.get('/get_world_cities/' + current_country[0].number, {
          headers: {
            'Accept': 'application/json',
          }
        }).then((response) => {
          self.citiestoinput = response.data;
        }).catch(error => {
          console.log(error);
        });
      }
    },
    isFieldRequired(key) {
      return this.$parent.isFieldRequired(key);
    },
    setRegion() {
      if (this.country === 'Российская Федерация') {
        const findItem = this.citiestoinput.find(el => el.ru_name === this.city);
        if(findItem) {
          this.region = findItem.region;
        }
      } else {
        this.region = '-';
      }
    },
    handleRegionClick() {
      if (this.country.length === 0) {
        alert('Выберите страну выше');
        return;
      }
      if (this.city.length === 0) {
        alert('Выберите город ниже');
        return;
      }
      alert('Это поле заполняется автоматически')
    }
  }
}
</script>

<style scoped>

</style>